import React from "react";
import { Fieldset } from "primereact/fieldset";
import { BreadCrumb } from "primereact/breadcrumb";

import Panel from "../../../components/panel/panel";
import { InputSwitch } from "primereact/inputswitch";
import { useState } from "react";

const CreateAccess = () => {
  const items = [
    {
      label: "Permissão de Acesso",
      url: "/returns",
    },
  ];
  const home = {
    icon: "fa fa-home",
  };

  const legendTemplate = (
    <div className="text-start d-flex justify-content-start text-success">
      <span className="pi pi-user mx-2"></span>
      <h4>Menu do Cliente</h4>
    </div>
  );

  const [checked, setChecked] = useState(false);

  return (
    <>
      <div className="col-md-4">
        <BreadCrumb
          model={items}
          home={home}
          style={{ background: "transparent", border: "none", fontSize: "16px" }}
        />
      </div>
      <Panel title="Permissão de Acesso">
        <div className="p-5">
          <div className="pb-5">
            <Fieldset legend={legendTemplate}>
              <div className="d-flex">
                <div className="col-md-2">
                  <p className="m-auto pb-2">Visualizar</p>
                  <InputSwitch
                    checked={checked}
                    onChange={(e) => setChecked(e.value)}
                  />
                </div>
                <div className="col-md-2">
                  <p className="m-auto pb-2">Criar</p>
                  <InputSwitch
                    checked={checked}
                    onChange={(e) => setChecked(e.value)}
                  />
                </div>
                <div className="col-md-2">
                  <p className="m-auto pb-2">Editar</p>
                  <InputSwitch
                    checked={checked}
                    onChange={(e) => setChecked(e.value)}
                  />
                </div>
                <div className="col-md-2">
                  <p className="m-auto pb-2">Vincular</p>
                  <InputSwitch
                    checked={checked}
                    onChange={(e) => setChecked(e.value)}
                  />
                </div>
              </div>
            </Fieldset>
          </div>
          <div>
            <Fieldset legend={legendTemplate}>
              <div className="d-flex">
                <div className="col-md-2">
                  <p className="m-auto pb-2">Visualizar</p>
                  <InputSwitch
                    checked={checked}
                    onChange={(e) => setChecked(e.value)}
                  />
                </div>
                <div className="col-md-2">
                  <p className="m-auto pb-2">Criar</p>
                  <InputSwitch
                    checked={checked}
                    onChange={(e) => setChecked(e.value)}
                  />
                </div>
                <div className="col-md-2">
                  <p className="m-auto pb-2">Editar</p>
                  <InputSwitch
                    checked={checked}
                    onChange={(e) => setChecked(e.value)}
                  />
                </div>
                <div className="col-md-2">
                  <p className="m-auto pb-2">Vincular</p>
                  <InputSwitch
                    checked={checked}
                    onChange={(e) => setChecked(e.value)}
                  />
                </div>
              </div>
            </Fieldset>
          </div>
        </div>
      </Panel>
    </>
  );
};

export default CreateAccess;
